import Router from './presentation/routes/Router';
import Layout from './presentation/components/layout/Layout';
import { LanguageProvider } from './context/LanguageContext';
import { CookieConsentProvider } from './context/CookieConsentContext';
import { ThemeProvider } from './context/ThemeContext';

export default function App() {
    return (
        <CookieConsentProvider>
        <LanguageProvider>
            <ThemeProvider>
                <Layout>
                    <Router />
                </Layout>
            </ThemeProvider>
        </LanguageProvider>
        </CookieConsentProvider>
    );
}
